export const CLIENT_ID_MS_TEAMS_BOT = 'ms-teams';
export const CLIENT_ID_SERVICE_TEAMS = 'service-teams-';
export const MY_IS_REDIRECT_FROM_TEAMS = 'redirect_from_teams';
export const BANNER_SEEN_KEY = 'hasSeenPrivacyBanner';
